const isBrowserMainThread = typeof window !== 'undefined' && window instanceof Window;
const isBrowserWebWorker = !isBrowserMainThread && typeof self !== 'undefined' && self instanceof Window;
const isBrowser = isBrowserMainThread || isBrowserWebWorker;
var LibraryEnvironment;

(function (LibraryEnvironment) {
  LibraryEnvironment["BROWSER"] = "browser";
  LibraryEnvironment["NODE"] = "node";
})(LibraryEnvironment || (LibraryEnvironment = {}));

const libraryEnvironment = isBrowser ? LibraryEnvironment.BROWSER : LibraryEnvironment.NODE;
const latestChromaticBuildURL = 'dev--60d39ad43a7c1f00494efb3e.chromatic.com';
/**
 * Check if a given hostname is a preview channel
 */

const isPreviewChannelHostname = hostname => hostname.includes('--') && hostname.endsWith('.web.app');
/**
 * Check if a given hostname is a Chromatic build URL
 */

const isChromaticBuildHostname = hostname => /^[a-f0-9]{24}-[a-z]+\.chromatic\.com$/.test(hostname);

export { LibraryEnvironment, isBrowser, isChromaticBuildHostname, isPreviewChannelHostname, latestChromaticBuildURL, libraryEnvironment };
